import { render } from "./SpeedNav.vue?vue&type=template&id=0224ece8&ts=true"
import script from "./SpeedNav.vue?vue&type=script&lang=ts&setup=true"
export * from "./SpeedNav.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/SpeedNav.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0224ece8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0224ece8', __exports__)) {
    api.reload('0224ece8', __exports__)
  }
  
  module.hot.accept("./SpeedNav.vue?vue&type=template&id=0224ece8&ts=true", () => {
    api.rerender('0224ece8', render)
  })

}


export default __exports__